import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DateComponent, DateVariant } from "components/base/DateComponent";
import DataGridView from "components/grid/DataGridView";
import { DataSourceVersionMetadata } from "./DataSourceVersionInfo";
import VersionStatusBadge from "./VersionStatusBadge";

const useStyles = makeStyles({
  grid: {
    "& .dx-data-row": { cursor: "pointer" }
  }
});

interface DataSourceVersionsProps {
  versions: DataSourceVersionMetadata[];
  onSelect: (version: string) => void;
}

/** Overview of all versions; selecting one opens its subpage. */
export default function DataSourceVersions({
  versions,
  onSelect
}: DataSourceVersionsProps) {
  const classes = useStyles();
  if (!versions.length)
    return <Typography variant="body2">No versions available.</Typography>;

  return (
    <div data-testid="data-source-versions">
      <DataGridView<DataSourceVersionMetadata>
        dataSource={versions}
        height="auto"
        allowSelection={false}
        showFilterRow={false}
        hoverStateEnabled
        gridClasses={{ root: classes.grid }}
        onRowClick={({ data }) => onSelect(data.version)}
        columns={[
          { colDef: { caption: "Version", dataField: "version" } },
          {
            colDef: { caption: "Status", dataField: "isLive" },
            render: ({ data }) => <VersionStatusBadge isLive={data.isLive} />
          },
          {
            colDef: {
              caption: "Created at",
              dataField: "creationDate",
              dataType: "datetime"
            },
            render: ({ data }) => (
              <DateComponent
                date={data.creationDate}
                variant={DateVariant.SHORT_WITH_TIME}
              />
            )
          },
          { colDef: { caption: "Comment", dataField: "comment" } }
        ]}
      />
    </div>
  );
}
